<template>
    <div  class="mcontent">
        <layout type="L_R" 
            v-if="root.device!='phone'"
        >
            <layout
                flex='2'
                type="T_B"
            >
                <layout
                    type="L_R"
                    flex='1'
                >
                    <wrapper style="margin-top: -0.6vw;">
                        <cusbox txt="微商城&天猫近30日销售趋势">
                            <dv-loading v-if='!getMicroMallAndTmallSalesTrendInRecent30daysShow'>Loading...</dv-loading>
                            <char1  :datalist="cdata1" :datelist="datelist"/>
                            
                        </cusbox>
                    </wrapper>
                    <layout
                        flex='1'
                        type="T_B"
                    >
                        <wrapper flex='5'>
                            <cusbox :showtxt='false'>
                                <layout type="L_R" v-if="JSON.stringify(getAnnualOnlineSalesValue.data)!='[]'">
                                    <layout type="T_B" >
                                        <div flex='2'>
                                            <cell>
                                                <div>
                                                    <layout type="L_R">
                                                        <cell><img
                                                                class="img1"
                                                                src='@/assets/i5.png'
                                                            /></cell>
                                                        <cell>
                                                            <div >
                                                                <div class="txt1">年度线上销售总额</div>
                                                                <div class="txt2">￥{{getAnnualOnlineSalesValue.money}}</div>
                                                            </div>
                                                            
                                                        </cell>
                                                    </layout>
                                                   
                                                </div>
                                                 
                                            </cell>
                                        </div>
                                    </layout>
                                    <layout type="T_B">
                                        <char2
                                            v-if="JSON.stringify(getAnnualOnlineSalesValue.data)!='[]'"
                                            :data="getAnnualOnlineSalesValue.data"
                                            :rd="['0%', '50%']"
                                        />
                                    </layout>
                                    
                                </layout>
                                <dv-loading v-else>Loading...</dv-loading>
                            </cusbox>
                        </wrapper>
                        <wrapper flex='5'>
                            <cusbox :showtxt='false'>
                                <layout type="L_R" v-if="JSON.stringify(getOnlineSalesTodayValue.data)!='[]'">
                                    <layout type="T_B">
                                        <div flex='2'>
                                            <cell>
                                                <div>
                                                    <layout type="L_R">
                                                        <cell><img
                                                                class="img1"
                                                                src='@/assets/i6.png'
                                                            /></cell>
                                                        <cell>
                                                            <div>
                                                                <div class="txt1">今日线上销售总额</div>
                                                                <div class="txt2">￥{{getOnlineSalesTodayValue.money}}</div>
                                                            </div>
                                                        </cell>
                                                    </layout>
                                                </div>
                                            </cell>
                                        </div>
                                    </layout>
                                    <layout type="T_B">
                                        <char2
                                            v-if="JSON.stringify(getOnlineSalesTodayValue.data)!='[]'"
                                            :data="getOnlineSalesTodayValue.data"
                                            :rd="['0%', '50%']"
                                        />
                                      
                                    </layout>
                                </layout>
                                <dv-loading v-else>Loading...</dv-loading>
                            </cusbox>
                        </wrapper>

                    </layout>
                </layout>
                <layout
                    type="L_R"
                    flex='1.5'
                >
                    <wrapper>
                        <cusbox txt="微商城访问次数">
                            <layout type="L_R" v-if="JSON.stringify(vlist)!='[]'">
                                <layout type="T_B">
                                    <div class="wxshop">
                                        <cell><img
                                                class="img1"
                                                src='@/assets/i6.png'
                                            /></cell>
                                        <cell>
                                            <div>
                                                <div class="txt1">微商城今日访问次数(PV)</div>
                                                 <div >
                                                    <span class="txt2">{{getNumberOfVisitsToMicroMallNumberValue.todayPv}}</span>
                                                    <span class="txt2_remark">较昨日</span>
                                                    <span ><img src="" alt=""></span>
                                                </div>
                                            </div>
                                        </cell>
                                        <cell class="center_img"><img
                                                class="img1"
                                                src='@/assets/i7.png'
                                            /></cell>
                                        <cell class="center_remark">
                                            <div>
                                                <div class="txt1">微商城今日独立访客数(UV)</div>
                                                 <div >
                                                    <span class="txt2">{{getNumberOfVisitsToMicroMallNumberValue.todayUv}}</span>
                                                    <span class="txt2_remark">较昨日</span>
                                                    <span ><img src="" alt=""></span>
                                                </div>
                                            </div>
                                        </cell>
                                        <cell><img
                                                class="img1"
                                                src='@/assets/i8.png'
                                            /></cell>
                                        <cell>
                                            <div>
                                                <div class="txt1">微商城今日销售额</div>
                                                <div >
                                                    <span class="txt2">{{getNumberOfVisitsToMicroMallNumberValue.money}}</span>
                                                    <span class="txt2_remark">较昨日</span>
                                                    <span ><img src="" alt=""></span>
                                                </div>
                                            </div>
                                        </cell>
                                    </div>
                                    <char3  :xlist='timelist' :data='vlist'/>
                                </layout>
                            </layout>
                            <dv-loading v-else>Loading...</dv-loading>
                        </cusbox>
                    </wrapper>
                </layout>
            </layout>
            <layout
                flex='1'
                type="T_B"
            >
                <wrapper flex='5'>
                    <cusbox txt="微商城&天猫销量TOP50商品">
                        <itemlist
                            :count='5'
                            :columns='columns1'
                            :data='data1'
                            v-if="getMicroMallAndTmallTop50ProductsShow"
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                            <template
                                slot-scope="{data}"
                                slot="img"
                            >
                                <img
                                    style="width:2.5vw"
                                    :src="data.img"
                                />
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </wrapper>
                <wrapper flex='5'>
                    <cusbox txt="微商城访问最多TOP50商品">
                        <itemlist
                            :count='5'
                            :columns='columns2'
                            v-if="getTop50CommoditiesVisitedMostInMicroMallShow"
                            :data='data2'
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:1vw"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                            <template
                                slot-scope="{data}"
                                slot="img"
                            >
                                <img
                                    style="width:2.5vw"
                                    :src="data.img"
                                />
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </wrapper>

            </layout>

        </layout>

           <mobile class="device_phone ppd notransform"  v-else>
                <div style="height:150px;margin-top:10px;">            
                         <cusbox :showtxt='false'>
                                <layout type="L_R" v-if="JSON.stringify(getAnnualOnlineSalesValue.data)!='[]'">
                                    <layout type="T_B" flex='1'>
                                        <div flex='2'>
                                            <cell>
                                                <div>
                                                    <layout type="L_R">
                                                        <cell><img
                                                                class="img1"
                                                                src='@/assets/i5.png'
                                                            /></cell>
                                                        <cell>
                                                            <div>
                                                                <div class="txt1">年度线上销售总额</div>
                                                                <div class="txt2">￥{{getAnnualOnlineSalesValue.money}}</div>
                                                            </div>
                                                        </cell>
                                                    </layout>
                                                </div>
                                            </cell>
                                        </div>
                                    </layout>
                                    <layout type="T_B"  flex='2'>
                                        <char2
                                            v-if="JSON.stringify(getAnnualOnlineSalesValue.data)!='[]'"
                                            :data="getAnnualOnlineSalesValue.data"
                                            :rd="['0%', '40%']"
                                        />
                                    </layout>
                                </layout>
                                <dv-loading v-else>Loading...</dv-loading>
                            </cusbox>        
                </div>
                 <div style="height:150px;margin-top:10px;">            
                            <cusbox :showtxt='false'>
                                <layout type="L_R" v-if="JSON.stringify(getOnlineSalesTodayValue.data)!='[]'">
                                    <layout type="T_B" flex='1'>
                                        <div flex='2'>
                                            <cell>
                                                <div>
                                                    <layout type="L_R">
                                                        <cell><img
                                                                class="img1"
                                                                src='@/assets/i6.png'
                                                            /></cell>
                                                        <cell>
                                                            <div>
                                                                <div class="txt1">今日线上销售总额</div>
                                                                <div class="txt2">￥{{getOnlineSalesTodayValue.money}}</div>
                                                            </div>
                                                        </cell>
                                                    </layout>
                                                </div>
                                            </cell>
                                        </div>
                                    </layout>
                                    <layout type="T_B" flex='2'>
                                        <char2
                                            v-if="JSON.stringify(getOnlineSalesTodayValue.data)!='[]'"
                                            :data="getOnlineSalesTodayValue.data"
                                            :rd="['0%', '40%']"
                                        />
                                      
                                    </layout>
                                </layout>
                                <dv-loading v-else>Loading...</dv-loading>
                            </cusbox>
                </div>
                <div style="height:250px;margin-top:10px;"> 
                        <cusbox txt="微商城&天猫近30日销售趋势">
                            <dv-loading v-if='!getMicroMallAndTmallSalesTrendInRecent30daysShow'>Loading...</dv-loading>
                            <char1  :datalist="cdata1" :datelist="datelist"/>
                        </cusbox>
                </div>
                <div style="height:350px;margin-top:10px;">
                         <cusbox txt="微商城访问次数">
                            <layout type="L_R" v-if="JSON.stringify(vlist)!='[]'">
                                <layout type="T_B">
                                    <div class="wxshop">
                                        <cell><img
                                                class="img1"
                                                src='@/assets/i6.png'
                                            /></cell>
                                        <cell>
                                            <div>
                                                <div class="txt1">微商城今日访问次数(PV)</div>
                                                 <div >
                                                    <span class="txt2">221113</span>
                                                    <span class="txt2_remark">较昨日</span>
                                                    <span ><img src="" alt=""></span>
                                                </div>
                                            </div>
                                        </cell>
                                        <cell class="center_img"><img
                                                class="img1"
                                                src='@/assets/i7.png'
                                            /></cell>
                                        <cell class="center_remark">
                                            <div>
                                                <div class="txt1">微商城今日独立访客数(UV)</div>
                                                 <div >
                                                    <span class="txt2">221113</span>
                                                    <span class="txt2_remark">较昨日</span>
                                                    <span ><img src="" alt=""></span>
                                                </div>
                                            </div>
                                        </cell>
                                        <cell><img
                                                class="img1"
                                                src='@/assets/i8.png'
                                            /></cell>
                                        <cell>
                                            <div>
                                                <div class="txt1">微商城今日销售额</div>
                                                <div >
                                                    <span class="txt2">221113</span>
                                                    <span class="txt2_remark">较昨日</span>
                                                    <span ><img src="" alt=""></span>
                                                </div>
                                            </div>
                                        </cell>
                                    </div>
                                    <char3 :xlist='timelist' :data='vlist'/>
                                </layout>
                            </layout>
                            <dv-loading v-else>Loading...</dv-loading>
                        </cusbox>
                </div>
                <div style="height:250px;margin-top:10px;">
                    <cusbox txt="微商城&天猫销量TOP50商品">
                        <itemlist
                            :count='5'
                            :columns='cols_1'
                            :data='data1'
                            v-if="getMicroMallAndTmallTop50ProductsShow"
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                         style="width:15px"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                         style="width:15px"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:15px"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                            <template
                                slot-scope="{data}"
                                slot="img"
                            >
                                <img
                                      class="icon"
                                    src="@/assets/touxiang.png"
                                />
                            </template>
                        </itemlist>
                         <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                </div>
                 <div style="height:250px;margin-top:10px;">
                  <cusbox txt="微商城访问最多TOP50商品">
                        <itemlist
                            :count='5'
                            :columns='cols_2'
                            v-if="getTop50CommoditiesVisitedMostInMicroMallShow"
                            :data='data2'
                        >
                            <template
                                slot="ranking"
                                slot-scope="{data}"
                            >
                                <span v-if="data.ranking==1">
                                    <img
                                        style="width:15px"
                                        src="@/assets/no1.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==2">
                                    <img
                                        style="width:15px"
                                        src="@/assets/no2.png"
                                    />
                                </span>
                                <span v-else-if="data.ranking==3">
                                    <img
                                        style="width:15px"
                                        src="@/assets/no3.png"
                                    />
                                </span>
                                <span v-else>
                                    {{data.ranking}}
                                </span>
                            </template>
                            <template
                                slot-scope="{data}"
                                slot="img"
                            >
                                <img
                                    class="icon"
                                    src="@/assets/touxiang.png"
                                />
                            </template>
                        </itemlist>
                        <dv-loading v-else>Loading...</dv-loading>
                    </cusbox>
                     </div>
           </mobile>
    </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import imenu from "../common/other/imenu.vue";
import itemlist from "@/components/cuscom/itemlist";
import char1 from "./report/char1.vue";
import char2 from "./report/char2.vue";
import char3 from "./report/char3.vue";
import cell from "@/components/cuscom/cell.vue";
import {cols_1,cols_2} from "./device/phone_column.js"
export default {
  components: {
    layout,
    wrapper,
    cusbox,
    imenu,
    itemlist,
    cell,
    char1,
    char2,
    char3
  },
     inject:['root'],
  data() {
    return {
        cols_1,
        cols_2,
      cdata1:{
          data1:[],
          data2:[]
      },
      timelist:[],
      vlist:{
          data1:[],
          data2:[],
          data3:[],
          data4:[],
      },
      datelist:[],
      getOnlineSalesTodayValue:{
          data:[],
          money:0
      },
      getAnnualOnlineSalesValue:{
          data:[],
          money:0
      },
      char2data: [
        {
          value: 20,
          name: "天猫旗舰店",
          itemStyle: { color: "#EACD2C" },
          showvalue: "￥9000"
        },
        {
          value: 25,
          name: "微商城",
          itemStyle: { color: "#2D56FF" },
          showvalue: "￥45000"
        },
        {
          value: 25,
          name: "员购会",
          itemStyle: { color: "#4346D3" },
          showvalue: "￥9500"
        }
      ],
      columns2: [
        {
          title: "排名",
          key: "ranking",
          align: "center",
          slot: "ranking",
              width: "2.5vw"
        },
        {
          title: "图片",
          key: "img",
          align: "center",
          slot: "img",
            width: "3vw"
        },
        {
          title: "货号",
          key: "goodsno",
          align: "center",
           width: "6vw"
        },
        {
          title: "商品浏览量",
          key: "goods_browse",
          align: "center"
        },
        {
          title: "商品访客数",
          key: "goods_visitor",
          align: "center"
        },
        {
          title: "支付件数",
          key: "pay_number",
          align: "center"
        },
        {
          title: "店铺销售件数",
          key: "shopsale_number",
          align: "center"
        }
      ],
      columns1: [
        {
          title: "排名",
          key: "ranking",
          align: "center",
          slot: "ranking",
          width: "2.5vw"
        },
        {
          title: "图片",
          key: "img",
          align: "center",
          slot: "img",
          width: "3vw"
        },
        {
          title: "货号",
          key: "goodsno",
          align: "center",
           width: "6vw"
        },
        {
          title: "支付买家数",
          key: "pay_buyer",
          align: "center"
        },
        {
          title: "支付件数",
          key: "pay_number",
          align: "center"
        },
        {
          title: "支付金额",
          key: "pay_amount",
          align: "center"
        },
        {
          title: "店铺销售件数",
          key: "shopsale_number",
          align: "center"
        }
      ],
      data1: [],
      data2: [],
      api:this.$apis['online'],
      getNumberOfVisitsToMicroMallNumberValue:{},
      getMicroMallAndTmallSalesTrendInRecent30daysShow:false,
      getMicroMallAndTmallTop50ProductsShow:false,
      getTop50CommoditiesVisitedMostInMicroMallShow:false
    };
  },
 
  methods:{
      get1(){
          this.api.getMicroMallAndTmallSalesTrendInRecent30days().then(res=>{
                 let that = this
              if(res.data.list){
                  let arr1=[]
                  let arr2=[]
                  for(var i=0;i<res.data.list.length;i++){
                      this.datelist.push(res.data.list[i].date)
                      if(res.data.list[i].plantForm=='微商城'){
                        arr1.push({
                            value:res.data.list[i].money
                        })
                      }else{
                        arr2.push({
                            value:res.data.list[i].money
                        });
                      }
                  }
                this.getMicroMallAndTmallSalesTrendInRecent30daysShow=true
                setTimeout(function(){
                that.cdata1.data1=arr1;
                that.cdata1.data2=arr2;
                },0)
              }
            
                
                // this.datelist=['9-1','9-2','9-3','9-4','9-5','9-6','9-7','9-8','9-9']
              
           

          })
      },
      get2(){
       
            this.api.get2().then(res=>{     
               this.vlist.data1=res.data.list[0].value;//今日pv    
               this.vlist.data2=res.data.list[1].value;//昨日PV
               this.vlist.data3=res.data.list[2].value;//7天前PV
               this.vlist.data4=res.data.list[3].value;//30天前PV
                var listime=[];
                for (let index = 0; index <= 24; index++) {
                    listime.push(`${index}:00`)
                    
                }
                this.timelist=listime;
            })
            // 微商城访问次数----折线部分
            this.api.getNumberOfVisitsToMicroMallLine().then(res=>{             
                var listime=[];
                var data1=[]
                var data2=[]
                var data3=[]
                var data4=[]
                for (let index = 0;index< res.data.list.length ; index++) {
                    listime.push(res.data.list[index].time)
                    data1.push(res.data.list[index].todayPv)
                    data2.push(res.data.list[index].yesterdayPv)
                    data3.push(res.data.list[index].day7AgoPv)
                    data4.push(res.data.list[index].day30AgoPv)
                }
                this.vlist={
                    data1,
                    data2,
                    data3,
                    data4,
                }
                this.timelist=listime;
            })
            // 微商城访问次数----数字部分
            this.api.getNumberOfVisitsToMicroMallNumber().then(res=>{
                this.getNumberOfVisitsToMicroMallNumberValue = res.data
            })
      }
  },
  mounted() {
       this.get1();
       this.get2();
       this.api.getAnnualOnlineSales().then(res=>{          
           if(res.data.list){
               let arr = []
               for(var i =0;i<res.data.list.length-1;i++){
                arr.push({
                    value: res.data.list[i].money,
                    name:res.data.list[i].plantForm,
                    itemStyle: { color:i==1? "#EACD2C":i==2?"#2D56FF": "#4346D3" },
                    showvalue: '￥'+res.data.list[i].saleMoney
                })

               }
               this.getAnnualOnlineSalesValue.money=res.data.list[3].saleMoney
               this.getAnnualOnlineSalesValue.data= arr
           }
       })
       this.api.getOnlineSalesToday().then(res=>{
               
           if(res.data.list){
               let arr2 = []
               for(var s =0;s<res.data.list.length;s++){
                   if(s!=0){
                    arr2.push({
                        value: res.data.list[s].money,
                        name:res.data.list[s].plantForm,
                        itemStyle: { color:s==1? "#EACD2C":s==2?"#2D56FF": "#4346D3" },
                        showvalue: '￥'+res.data.list[s].money
                    })
                   }
               }
               this.getOnlineSalesTodayValue.money=res.data.list[0].money
               this.getOnlineSalesTodayValue.data= arr2
           } 
       })
       var list1=[];
       var list2=[];
     this.api.getMicroMallAndTmallTop50Products().then(res=>{
         if(res.data.list){
             for (var j = 1; j < res.data.list.length; j++) {
            list1.push({
                ranking: res.data.list[j].rank,
                img: res.data.list[j].pics,
                goodsno: res.data.list[j].goodsNo,
                pay_buyer: res.data.list[j].memberNum,
                pay_number: res.data.list[j].goodSaleNum,
                pay_amount: res.data.list[j].money,
                shopsale_number:  res.data.list[j].storeSaleNum
            });
            }
            this.getMicroMallAndTmallTop50ProductsShow = true
            let that = this
            setTimeout(function(){
                that.data1=list1;
            })
            
         }
    })
    this.api.getTop50CommoditiesVisitedMostInMicroMall().then(res=>{
         if(res.data.list){
            for (var f = 1; f < res.data.list.length; f++) {
            list2.push({
                ranking: res.data.list[f].rank,
                img: res.data.list[f].pics,
                goodsno: res.data.list[f].goodsNo,
                goods_browse: res.data.list[f].goodsVisit,
                goods_visitor: res.data.list[f].goodsGuestVisit,
                pay_number: res.data.list[f].goodSaleNum,
                shopsale_number:  res.data.list[f].storeSaleNum
            });
            }
            this.getTop50CommoditiesVisitedMostInMicroMallShow = true
            let that = this
            setTimeout(function(){
                that.data2=list2;
            },0)
          
         }
    })
  
  
  
  }
};
</script>
<style lang="scss" scoped>
.mcontent {
  color: #fff;
  height: 100%;
  display: flex;
  .txt1 {
    font-size: 1vw;
    color: #a7afe2;
  }
  .txt2 {
    font-size: 2vw;
  }
  .img1{
      width: 2vw;
      margin-right: 0.5vw;
  }
  .wxshop{
      display:flex;justify-content: center;
      .center_img{
          margin-left: 1vw;
      }
      .center_remark{
          margin-right: 1vw;
      }
      .txt2_remark{
          margin-left: 0.5vw;
      }
     
  }
}
</style>